/**
 * Created by nmayer on 09.06.16.
 */
define('modules/settings/classification/ClassificationFormController',[
	'modules/module',
	'modules/basemodule/controllers/EntityFormController',
	'services/ValidationService',
	'settings',
], function (module) {
	'use strict';
	module.controller('ClassificationFormController', [
		'$scope',
		'$controller',
		'BASE_TEMPLATES_PATH',
		'ValidationService',
		function ($scope, $controller, BASE_TEMPLATES_PATH, ValidationService) {
			angular.extend(
				this,
				$controller('EntityFormController', {
					$scope: $scope,
				})
			);

			$scope.state.requireSuperuserForUpdate = true;

			$scope.formTabs = [
				{
					label: 'FIELDS.GENERAL',
					template: BASE_TEMPLATES_PATH + '/settings/classification/form-main.html',
					active: true,
				},
			];
			$scope.init('Classification').then(function () {});

			$scope.listState = 'root.classifications';

			$scope.validate = function () {
				return ValidationService.validate($scope.entity, {
					name: {
						method: 'isset',
						fieldName: 'Name',
					},
				});
			};
		},
	]);
});

